import { QueryState } from 'redux-query';
import { useSelector } from 'react-redux';
import { ForceRequestCallback, useRequest } from 'redux-query-react';
import { ServiceLocationInfo, State } from 'types';
import { getServiceLocationsQuery } from './serviceLocationsQueries';
import { getServiceLocation, getServiceLocations } from './serviceLocationsSelectors';

export const useServiceLocations = (
  practiceId: number,
): [ServiceLocationInfo[] | undefined, QueryState, ForceRequestCallback] => {
  const [queryState, refresh] = useRequest(getServiceLocationsQuery(practiceId));
  const serviceLocations = useSelector(getServiceLocations);
  return [serviceLocations, queryState, refresh];
};

export const useServiceLocation = (
  practiceId: number,
  serviceLocationId: number,
): [ServiceLocationInfo | undefined, QueryState, ForceRequestCallback] => {
  const [queryState, refresh] = useRequest(getServiceLocationsQuery(practiceId));
  const serviceLocation = useSelector((state: State) =>
    getServiceLocation(state, serviceLocationId),
  );
  return [serviceLocation, queryState, refresh];
};
